// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4a28b638","977":"3c76c196"}[chunkId] + ".chunk.js";
};